import { render, staticRenderFns } from "./TeamDashboard.vue?vue&type=template&id=dd82cf8a&"
import script from "./TeamDashboard.vue?vue&type=script&lang=ts&"
export * from "./TeamDashboard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports